import React, { useState, useEffect, useCallback } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Wrapper, Map, WrapperMap, WrapperScroller, ColMap } from './style.css'

import Mapa from '../Mapa'
import Scroller from '../Scroller'
import Numbers from '../Mapa/Numbers'

const normalize = str => {
  const map = {
    '': ' |:|/',
    a: 'á|à|ã|â|À|Á|Ã|Â',
    e: 'é|è|ê|É|È|Ê',
    i: 'í|ì|î|Í|Ì|Î',
    o: 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
    u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
    c: 'ç|Ç',
    n: 'ñ|Ñ',
  }

  try {
    let strlow = str.trim().toLowerCase()

    for (let pattern in map) {
      strlow = strlow.replace(new RegExp(map[pattern], 'g'), pattern)
    }
    let out = strlow.replace(/[^a-zA-Z0-9\-]/g, '').replace(/-{2,}/g, '')
    if (out.endsWith('-')) return out.slice(0, -1)
    return out
  } catch (err) {
    console.log('el str:', str)
    console.log('typeof', typeof str)
    console.log('el err:', JSON.stringify(err))
  }
}

const Composer = () => {
  const { puntos } = useStaticQuery(graphql`
    query {
      puntos: allGoogleSpreadsheetPuntosOkPuntosOk(sort: { fields: fecha }) {
        nodes {
          id
          comuna: comunas
          delitos: delito
          fecha
          latitud
          longitud
          ruc
        }
      }
    }
  `)

  const nodes = puntos.nodes.map(node => {
    return { ...node, slugComuna: normalize(node.comuna) }
  })
  const [visibles, setVisibles] = useState([])
  const [allVisibles, setAllVisibles] = useState([])
  const [acumulados, setAcumulados] = useState([])
  const [epoca, setEpoca] = useState()

  const trimestreTitulo = texto => {
    return `${
      texto.endsWith('4')
        ? 'Cuarto Trimestre'
        : texto.endsWith('3')
        ? 'Tercer Trimestre'
        : texto.endsWith('2')
        ? 'Segundo Trimestre'
        : texto.endsWith('0')
        ? 'Anterior al'
        : 'Primer Trimestre'
    } ${texto.split('-')[0]} `
  }

  const generateDates = fecha => {
    const date = new Date(fecha)
    const year = date.getFullYear()
    const trimester = Math.floor(date.getMonth() / 3) + 1
    return { year, trimester }
  }

  const groupByTrimester = list => {
    return list.reduce((group, node) => {
      // console.log('😂', node.fecha)
      const { year, trimester } = generateDates(node.fecha)
      const groupKey = year < 2020 ? `2020-0` : `${year}-${trimester}`
      // console.log('🤔', groupKey)
      ;(group[groupKey] = group[groupKey] || []).push({
        ...node,
        year,
        trimester,
      })

      return group
    }, {})
  }

  const trimestres = groupByTrimester(nodes)

  const selectPastTrimestres = (nodes, actualTrimesterKey) => {
    const arr = Object.keys(nodes)
    const fromindex = arr.findIndex(item => item === actualTrimesterKey)
    arr.splice(fromindex, arr.length - fromindex)
    const out = []
    arr.map(key => {
      out.push(...nodes[key])
    })
    return out
  }

  const handleVisible = key => {
    setAcumulados(selectPastTrimestres(trimestres, key))
    // setIncidentesAcumulados()
    setEpoca(trimestreTitulo(key))
    setVisibles([...trimestres[key]])
    setAllVisibles([])
  }

  const extractAllNodesFromTrimestres = nodes => {
    const out = []
    Object.keys(nodes).map(node => {
      out.push(...nodes[node])
    })
    return out
  }

  const handleAllVisible = () => {
    setAcumulados([])
    setEpoca('Todos los incidentes 2015-2021')
    setVisibles(extractAllNodesFromTrimestres(trimestres))
    setAllVisibles(extractAllNodesFromTrimestres(trimestres))
  }

  const calculateComunas = nodes => {
    const comunas = []
    nodes.map(node => {
      comunas.push(node.comuna)
    })
    const unique = [...new Set(comunas)]
    return unique.length
  }

  const [comunasAfectadas, setComunasAfectadas] = useState(0)
  const [allComunasAfectadas, setAllComunasAfectadas] = useState(0)
  const [triggeredNodes, setTriggeredNodes] = useState(false)
  const [resetMapView, setResetMapView] = useState(false)
  const [mapViewToAllVisibles, setMapViewToAllVisibles] = useState(false)
  const [globalMode, setGlobalMode] = useState(false)

  useEffect(() => {
    const localCalc = calculateComunas(visibles)
    if (localCalc !== comunasAfectadas) {
      setComunasAfectadas(localCalc)
    }
    if (visibles.length > 0) {
      setGlobalMode(false)
    }
  }, [visibles])

  useEffect(() => {
    const localCalc = calculateComunas(allVisibles)
    if (localCalc !== comunasAfectadas) {
      setAllComunasAfectadas(localCalc)
    }
    if (allVisibles.length > 0) {
      setGlobalMode(true)
    }
  }, [allVisibles])

  const handleTriggerMapChange = nodes => {
    setTriggeredNodes(nodes)
    setVisibles([
      ...visibles.map(node => ({
        ...node,
        triggered: nodes.find(n => n.id === node.id) ? true : false,
      })),
    ])
    setResetMapView(false)
  }

  const handleTriggerMapChangeAll = nodes => {
    // console.log('handleTriggerMapChangeAll', nodes)
    const localAll = extractAllNodesFromTrimestres(trimestres)
    setAllVisibles([
      ...localAll.map(node => ({
        ...node,
        triggered: nodes.find(n => n.id === node.id) ? true : false,
      })),
    ])
    // setTriggeredNodes(nodes)
    // setVisibles([
    //   ...visibles.map(node => ({
    //     ...node,
    //     triggered: nodes.find(n => n.id === node.id) ? true : false,
    //   })),
    // ])
    // setResetMapView(false)
  }

  const handleResetMapView = () => {
    setTriggeredNodes(false)
    setResetMapView(true)
  }

  const handleSetMapViewToAllVisibles = () => {
    const allNodes = extractAllNodesFromTrimestres(trimestres)
    setTriggeredNodes([])
    setResetMapView(false)
    setMapViewToAllVisibles(true)
  }

  const triggerNodes = () => {
    if (triggeredNodes) {
      return triggeredNodes
    }
  }

  const triggerResetMapView = () => {
    if (resetMapView) {
      return resetMapView
    }
  }

  const triggerMapViewToAllVisibles = () => {
    if (mapViewToAllVisibles) {
      return mapViewToAllVisibles
    }
  }

  return (
    <Wrapper>
      <ColMap>
        <WrapperMap>
          <Map>
            <Numbers
              className="absolute z-10"
              comunas={globalMode ? allComunasAfectadas : comunasAfectadas}
              incidentes={globalMode ? allVisibles.length : visibles.length}
              acumulados={
                globalMode
                  ? allVisibles.length
                  : acumulados.length + visibles.length
              }
              epoca={epoca}
              globalMode={globalMode}
            />
            <Mapa
              nodes={visibles}
              acumulados={acumulados}
              allVisibles={allVisibles}
              triggerFromOutside={triggerNodes()}
              resetMapView={triggerResetMapView()}
              onTriggerMapAll={triggerMapViewToAllVisibles()}
            />
          </Map>
        </WrapperMap>
      </ColMap>
      <WrapperScroller>
        <Scroller
          trimestres={trimestres}
          allVisibles={allVisibles}
          allComunasAfectadas={allComunasAfectadas}
          comunasAfectadas={comunasAfectadas}
          onVisible={handleVisible}
          onAllVisible={handleAllVisible}
          triggerMapChange={handleTriggerMapChange}
          triggerMapChangeAll={handleTriggerMapChangeAll}
          resetMapView={handleResetMapView}
          onTriggerMapAll={handleSetMapViewToAllVisibles}
        />
      </WrapperScroller>
    </Wrapper>
  )
}

export default Composer
